const SectionHeader = ({ icon: Icon, title, action, className = '' }) => (
  <div className={`flex min-w-0 flex-wrap items-center justify-between gap-3 mb-4 pb-3 border-b border-light-border-primary dark:border-dark-border-primary ${className}`}>
    <div className="flex min-w-0 items-center gap-2">
      {Icon && <Icon className="h-4 w-4 shrink-0 text-primary-500" />}
      <h2 className="min-w-0 break-words font-semibold text-light-text-primary dark:text-dark-text-primary">{title}</h2>
    </div>
    {action && <div className="flex min-w-0 flex-wrap items-center gap-2">{action}</div>}
  </div>
)

export default SectionHeader
